// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2GzUu","content":"GlobalSearch_content__10dEx"};